import { action, createRequestTypes } from './base';

export const tagActionTypes = {
  CREATE_TAG: createRequestTypes('CREATE_TAG'),
  GET_TAGS: createRequestTypes('GET_TAGS'),
};

class TagActions {
  /**
     *
     * @param entityName
     * @param page
     * @param limit
     * @param searchKeyword
     * @param callback
     */
   getTags = (entityName, page, limit, searchKeyword, callback) => action(tagActionTypes.GET_TAGS.REQUEST, {
     entityName, page, limit, searchKeyword, callback,
   });

      /**
       *
       * @param getTagsLoading
       */
      getTagsLoading = (getTagsLoading, entityName) => action(tagActionTypes.GET_TAGS.LOADING, {
        getTagsLoading,
        entityName,
      });

      /**
       *
       * @param getTagsSuccess
       */
      getTagsSuccess = (tags, entityName) => action(tagActionTypes.GET_TAGS.SUCCESS, {
        tags,
        entityName,
      });

      /**
   *
   * @param payload
   * @param callback
   */
  createTag = (payload, callback) => action(tagActionTypes.CREATE_TAG.REQUEST, {
    payload, callback,
  })

  /**
 *
 * @param createTagLoading
 */
    createTagLoading = (createTagLoading) => action(tagActionTypes.CREATE_TAG.LOADING, {
      createTagLoading,
    })
}

export default new TagActions();
